import axios from "axios";

// Initialize axios configuration
const initializeAxios = () => {
  const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/+$/,
    "",
  );

  // Set base URL
  axios.defaults.baseURL = API_BASE || "";

  // Set auth token from localStorage if it exists
  const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  // Add request interceptor to include token in all requests
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  // Add response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid - clear storage and redirect to login
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common.Authorization;
        window.location.href = "/";
      }
      return Promise.reject(error);
    },
  );
};

// Function to set token after login
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("token", token);
  }
};

// Function to clear auth token on logout
export const clearAuthToken = () => {
  delete axios.defaults.headers.common.Authorization;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export default initializeAxios;
